// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__YRH_L","modalFooterButton":"ModalNotes_modalFooterButton__23Vdf"};